import { render, staticRenderFns } from "./FocusableWithPagination.vue?vue&type=template&id=1436d876&"
import script from "./FocusableWithPagination.vue?vue&type=script&lang=js&"
export * from "./FocusableWithPagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports